import { NavigateFunction } from 'react-router-dom'
import { openWithTenant } from '@app-store'
import { FaxDetailsData } from '../../../types/intakeQueue.types'
import { DUPLICATE_POPUP, ENTITY_NAME } from '../../../utils/constants'
import { SaveCaseSummaryOutcomeParams } from './saveCaseSummaryOutcome'
import { procedureCallForCaseAttachment } from '../../../pages/intake-ques/multi-product/loadCaseWorkflow'

export interface DedupeOutcomeSaveFlowParams {
  attachedCaseId: string | number
  outcomeId: string
  outcomeReasonId: string
  outcomeReasonLabel: string
  attachCase: (caseId: string | number, reason: string) => Promise<void>
  updateStatusToCompleted?: () => void | Promise<void>
  faxDetails?: FaxDetailsData | null
  communicationId?: string | number
  caseDocumentTypeId?: number
  assigneeUserId?: number
  workflowInstanceId?: string
  caseId?: string | number
  workflowDefinition: SaveCaseSummaryOutcomeParams['workflowDefinition']
  onTaskCreationError?: (error: unknown) => void
  navigate?: NavigateFunction
  queueParams?: {
    entityid?: string
    layoutid?: string
    id?: string
  }
  requestorId?: number | null
  schemaName?: number | string | null
  redirectOnSave?: boolean
  createNewAttachmentTask?: boolean
  /** Skip process cancel/suspend in closeDuplicateWorkflowCase (e.g. already cancelled). */
  skipCloseProcessApi?: boolean
  closeProcess?: string
  onMultiProductCaseComplete?: () => void | Promise<void>
  fromInteraction?: boolean
  intakeCommunicationMap?: Record<string, unknown> | null
  intakeChannelId?: number | null
  intakeEntityName?: string | undefined
  onCaseAttachmentProcedure?: () => Promise<void>
}

export const executeDedupeOutcomeSaveFlow = async ({
  attachedCaseId,
  outcomeId,
  outcomeReasonId,
  updateStatusToCompleted,
  faxDetails,
  communicationId,
  caseDocumentTypeId,
  caseId,
  onTaskCreationError,
  navigate,
  queueParams,
  requestorId,
  schemaName,
  skipCloseProcessApi = false,
  onMultiProductCaseComplete,
  fromInteraction,
  intakeCommunicationMap,
  intakeChannelId,
  intakeEntityName,
}: DedupeOutcomeSaveFlowParams) => {
  try {
    const resolvedIntakeChannelId =
      intakeChannelId ??
      (intakeCommunicationMap && faxDetails?.channel?.id
        ? Number(intakeCommunicationMap[String(faxDetails.channel.id)]) || null
        : null)

    const resolvedCommunicationId =
      intakeEntityName === ENTITY_NAME.HCP_PORTAL_ENTITY
        ? null
        : communicationId
        ? Number(communicationId)
        : null

    await procedureCallForCaseAttachment(
      caseId ? Number(caseId) : null,
      Number(attachedCaseId),
      schemaName ?? '',
      outcomeId ? Number(outcomeId) : null,
      outcomeReasonId ? Number(outcomeReasonId) : null,
      resolvedIntakeChannelId,
      resolvedCommunicationId,
      requestorId ? Number(requestorId) : null,
      caseDocumentTypeId ? Number(caseDocumentTypeId) : null,
      fromInteraction
    )

    if (fromInteraction) {
      openWithTenant(
        `/entity/${ENTITY_NAME.CASE_ENTITY_ID}/workflow/review/${attachedCaseId}`,
        '_blank'
      )
      navigate?.(-1)
      return
    }
  } catch (error) {
    console.error(error)
    onTaskCreationError?.(error)
  }

  // This below function is voiding case in case of MultiProduct Enrollment
  // To be checked
  await updateStatusToCompleted?.()

  //skipCloseProcessApi = isMultiCaseEnabled
  if (skipCloseProcessApi) return
  if (onMultiProductCaseComplete) {
    openWithTenant(
      `/entity/${ENTITY_NAME.CASE_ENTITY_ID}/workflow/review/${attachedCaseId}`,
      '_blank'
    )
    return
  }

  openWithTenant(
    `/entity/${ENTITY_NAME.CASE_ENTITY_ID}/workflow/review/${attachedCaseId}?tabs=${DUPLICATE_POPUP.WORKFLOW_REVIEW_CORRESPONDENCE_TAB}`,
    '_blank'
  )

  const queueUrl =
    queueParams?.entityid && queueParams?.layoutid && queueParams?.id
      ? `/manage-queue/dynamic-queue/${queueParams.entityid}/${queueParams.layoutid}/${queueParams.id}`
      : '/manage-queue'

  if (navigate) {
    navigate(queueUrl)
  } else {
    openWithTenant(queueUrl, '_self')
  }
}
